import { useEffect } from "react";
import { Box, Chip } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

import { useEntityAchievements } from "../../../Entity/api/queries/useEntityAchievements";
import { getEntityAchievementsRoute } from "../../../../routers/routeUtils";

const AchievementsTab = ({
  isLoading,
  setCurrentAchievementName,
}: {
  isLoading: boolean;
  setCurrentAchievementName: (name: string) => void;
}) => {
  const navigate = useNavigate();
  const { entityId, achievementId: currentAchievementId } = useParams();

  const handleOnChangeType = (id: number) => {
    navigate(getEntityAchievementsRoute(entityId!, id));
  };

  const { data: achievements, isLoading: isAchievementsLoading } = useEntityAchievements(entityId!);

  const achievementsList = Object.entries(achievements || {}).map(([category, achievement]) => ({
    category,
    achievement,
  }));

  useEffect(() => {
    setCurrentAchievementName(
      achievementsList.find(({ achievement: { id } }) => id === Number(currentAchievementId))?.category || ""
    );
  }, [currentAchievementId, achievements]);

  return (
    <Box
      sx={{
        width: "100%",
        overflowX: "auto",
        whiteSpace: "nowrap",
        pb: "8px",
        mb: "16px",
      }}
    >
      <Box sx={{ display: "flex", gap: "10px", width: "fit-content" }}>
        {achievementsList.map(({ category, achievement: { id } }) => (
          <Chip
            key={id}
            label={category}
            component="button"
            variant="outlined"
            clickable
            onClick={() => handleOnChangeType(id)}
            disabled={isLoading || isAchievementsLoading}
            sx={{
              padding: "1px 4px",
              fontFamily: "Montserrat",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "20px",
              color: Number(currentAchievementId) === id ? "var(--Green---100, #008B07)" : "var(--Dark---600, #707070)",
              border: Number(currentAchievementId) === id ? "1px solid var(--Brand-600, #008B07)" : "none",
              background: Number(currentAchievementId) === id ? "var(--Brand-25, #F6FFF5)" : "transparent",
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default AchievementsTab;
